import { FileType } from 'src/models';

import { InvestigationConstant } from '../constants/investigations.constants';

export const findFileType = (originalName?: string): FileType => {
  const parts = originalName?.split('.') || [];
  const lastPart = parts[parts.length - 1];

  if (lastPart?.toLowerCase() === 'pdf') {
    return 'pdf';
  }

  if (InvestigationConstant.IMAGE_FILE_EXT_LIST.includes(lastPart.toLowerCase())) {
    return 'image';
  }

  throw new Error(`Unable to determine file type. Filename: ${lastPart}`);
};
